export const TEST_ID = 'serviceIntervalFields';

export const INTERVALS_FIELD_NAME = 'intervals';

export const UNITS_FIELD_NAME = 'units';
